<template>
    <div>
        <ul v-if="user" class="main-header__list">
            <li class="main-header__item">
                <a href="javascript:;" class="main-header__link" @click="openProfile()">{{ $helpers.trans('auth.profile') }}</a>
            </li>
            <li class="main-header__item">
                <a href="javascript:;" class="main-header__link" @click="logout()">{{ $helpers.trans('auth.logout') }}</a>
            </li>
        </ul>
        <ul v-else class="main-header__list">
            <li class="main-header__item">
                <a href="javascript:;" class="main-header__link" @click="openLogin()">{{ $helpers.trans('auth.login') }}</a>
            </li>
            <li class="main-header__item">
                <a href="javascript:;" class="main-header__link" @click="openRegister()">{{ $helpers.trans('auth.register') }}</a>
            </li>
        </ul>
    </div>
</template>
<script>
import Http from 'axios'
import LoginComponent from '#app#/components/package/RF/Member/modals/Login.vue'
import RegisterComponent from '#app#/components/package/RF/Member/modals/Register.vue'
import ProfileComponent from '#app#/components/package/RF/Member/modals/Profile.vue'

export default {
    data() {
        return {
            user: this.$user,
        }
    },

    methods: {
        openLogin() {
            this.$helpers.modal(this.$root, LoginComponent)
        },

        openRegister() {
            this.$helpers.modal(this.$root, RegisterComponent);
        },

        openProfile() {
            this.$helpers.modal(this.$root, ProfileComponent);
        },

        logout() {
            Http.post('/logout').then(() => {
                this.$user = null;
                this.user = null;
            });
        },
    },
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/package/RF/Member/FrontNav.vue